import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Icon, Field, PrimaryButton } from "@/components/kit";
import { api } from "@/api";

export default function RootLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const login = async () => {
    setLoading(true); setError("");
    try {
      await api.rootLogin(email.trim(), password);
      navigate("/root/accounts", { replace: true });
    } catch (e) {
      setError(e.message || "Identifiants incorrects");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-ink">
      <div className="mx-auto flex w-full max-w-md items-center justify-between px-5 pt-5">
        <Link to="/" data-testid="root-login-back-home" className="flex items-center gap-1.5 text-[14px] text-white/70 hover:text-white">
          <Icon name="arrow-left" size={16} /> Accueil
        </Link>
      </div>

      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-5 pb-16">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-white/10">
            <Icon name="shield" size={28} className="text-white" />
          </div>
          <h1 className="font-display text-3xl font-semibold text-white">Super Admin</h1>
          <p className="mt-1 text-[14px] text-white/60">Accès propriétaire — réservé.</p>
        </div>

        <div className="rounded-2xl border border-white/10 bg-white/5 p-6">
          <label className="mb-1 block text-[13px] font-medium text-white/70">Email</label>
          <input data-testid="root-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            autoCapitalize="none" autoCorrect="off" autoComplete="username" spellCheck={false} inputMode="email"
            placeholder="email@exemple.com"
            className="mb-3 w-full rounded-xl border border-white/15 bg-ink px-3.5 py-2.5 text-[15px] text-white placeholder-white/30 outline-none focus:border-white/40" />
          <label className="mb-1 block text-[13px] font-medium text-white/70">Mot de passe</label>
          <input data-testid="root-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            autoCapitalize="none" autoCorrect="off" autoComplete="current-password" spellCheck={false}
            onKeyDown={(e) => { if (e.key === "Enter" && email && password) login(); }}
            placeholder="••••••••"
            className="mb-4 w-full rounded-xl border border-white/15 bg-ink px-3.5 py-2.5 text-[15px] text-white placeholder-white/30 outline-none focus:border-white/40" />
          {error ? <p data-testid="root-error" className="mb-3 text-[14px] font-medium text-red-300">{error}</p> : null}
          <PrimaryButton testId="root-login-btn" title="Connexion" icon="log-in" onClick={login} loading={loading} disabled={!email || !password} />
        </div>
      </div>
    </div>
  );
}
